import { useState } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Plus, X } from "lucide-react";

// FITMENT, picked from his own make and model lists — never typed — and worded "call to confirm fitment".
export function FitmentPicker({ value, makes, onChange, testid }) {
  const [make, setMake] = useState("");
  const [model, setModel] = useState("");
  const models = makes.find((m) => m.name === make)?.models || [];
  const add = () => { onChange([...value, { make, model: model || null }]); setMake(""); setModel(""); };
  return (
    <div data-testid={testid} className="space-y-2">
      <div className="flex flex-wrap gap-1.5">
        {!value.length && <span className="text-xs text-slate-500">No fitment picked yet.</span>}
        {value.map((x, i) => (
          <span key={`${x.make}-${x.model}-${i}`} data-testid={`${testid}-tag-${i}`} className="inline-flex items-center gap-1 rounded-full border border-slate-300 bg-white pl-3 text-sm">
            {x.make}{x.model ? ` ${x.model}` : ""}
            <button type="button" data-testid={`${testid}-remove-${i}`} aria-label="Take it off" onClick={() => onChange(value.filter((_, j) => j !== i))}
              className="h-9 w-9 grid place-items-center rounded-full hover:bg-slate-100"><X className="w-4 h-4" /></button>
          </span>
        ))}
      </div>
      <div className="flex flex-wrap items-center gap-2">
        <Select value={make} onValueChange={(v) => { setMake(v); setModel(""); }}>
          <SelectTrigger data-testid={`${testid}-make`} className="h-11 w-44"><SelectValue placeholder="Make" /></SelectTrigger>
          <SelectContent>{makes.map((m) => <SelectItem key={m.name} value={m.name}>{m.name}</SelectItem>)}</SelectContent>
        </Select>
        <Select value={model} onValueChange={setModel} disabled={!models.length}>
          <SelectTrigger data-testid={`${testid}-model`} className="h-11 w-44"><SelectValue placeholder="Model (any)" /></SelectTrigger>
          <SelectContent>{models.map((m) => <SelectItem key={m} value={m}>{m}</SelectItem>)}</SelectContent>
        </Select>
        <button type="button" data-testid={`${testid}-add`} disabled={!make} onClick={add}
          className="inline-flex items-center gap-1.5 h-11 px-4 rounded-lg border-2 border-slate-300 bg-white text-sm font-bold hover:bg-slate-50 disabled:opacity-40">
          <Plus className="w-4 h-4" />Add</button>
      </div>
    </div>
  );
}
